import { useRef, useState } from 'react';
import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ModelOfFormUser } from 'src/database';

import api from 'src/services/api';
import { useAuth } from 'src/contexts/auth';

interface PersonProps {
	ID: string;
	NOME: string;
	DATANASCIMENTO: string;
	ORGAOUNIDADE: string;
}

export const useFormCreateUser = () => {
	const [loading, setLoading] = useState(false);
	const [userResponse, setUserResponse] = useState<AxiosResponse | null>(null);
	const [loadingPersonCpf, setLoadingPersonCpf] = useState(false);
	const [foundPersonCpf, setFoundPersonCpf] = useState(false);
	const [PersonCpf, setPersonCpf] = useState<PersonProps[]>([]);

	const { userAgencyId } = useAuth();
	const toast: any = useRef();
	const toastUserCpf: any = useRef();

	const validationSchema = Yup.object().shape({
		LOGIN: Yup.string().email('* Informe um email válido').required('* Campo Obrigatório'),
		SENHA: Yup.string().required('* Campo Obrigatório'),
		CPF: Yup.string().required('* Campo Obrigatório'),
		NIVEL: Yup.number().required('* Campo Obrigatório'),
	});

	const saveUser = (user: ModelOfFormUser) => {
		setLoading(true);

		const newUser = {
			CPF: user.CPF,
			LOGIN: user.LOGIN,
			SENHA: user.SENHA,
			ORGAOUNIDADE: PersonCpf[0].ORGAOUNIDADE,
			NIVEL: user.NIVEL,
			ORGAO: userAgencyId,
		};

		if (PersonCpf[0] && PersonCpf[0].ORGAOUNIDADE !== null) {
			api.post('register', newUser)
				.then((response) => {
					setUserResponse(response);
					setLoading(false);
					formik.resetForm();
					toast.current.show([
						{
							severity: 'success',
							summary: 'Cadastro realizado',
							detail: 'Usuário cadastrado com sucesso!',
							life: 5000,
						},
					]);
				})
				.catch(() => {
					setLoading(false);
					toast.current.show([
						{
							severity: 'error',
							summary: 'Cadastro não realizado',
							detail: 'Falha ao cadastrar usuário!',
							life: 5000,
						},
					]);
				});
		} else {
			newUser.ORGAOUNIDADE = PersonCpf[0].ORGAOUNIDADE;
			const newPerson = {
				ORGAO: userAgencyId,
				NOME: PersonCpf[0].NOME,
				DATANASCIMENTO: PersonCpf[0].DATANASCIMENTO,
				CPF: user.CPF,
				ORGAOUNIDADE: user.ORGAOUNIDADE,
				CARGO: user.CARGO,
			};

			api.post(`people/${PersonCpf[0].ID}`, newPerson)
				.then(() => {
					api.post('register', newUser)
						.then((response) => {
							setUserResponse(response);
							setLoading(false);
							formik.resetForm();
							toast.current.show([
								{
									severity: 'success',
									summary: 'Cadastro realizado',
									detail: 'Pessoa cadastrada com sucesso!',
									life: 5000,
								},
								{
									severity: 'success',
									summary: 'Cadastro realizado',
									detail: 'Usuário cadastrado com sucesso!',
									life: 5000,
								},
							]);
						})
						.catch(() => {
							setLoading(false);
							toast.current.show([
								{
									severity: 'success',
									summary: 'Cadastro realizado',
									detail: 'Pessoa cadastrada com sucesso!',
									life: 5000,
								},
								{
									severity: 'error',
									summary: 'Cadastro não realizado',
									detail: 'Falha ao cadastrar usuário!',
									life: 5000,
								},
							]);
						});
				})
				.catch((err) => {
					console.log(err);
					setLoading(false);
					toast.current.show([
						{
							severity: 'error',
							summary: 'Cadastro não realizado',
							detail: 'Falha ao cadastrar usuário!',
							life: 5000,
						},
						{
							severity: 'error',
							summary: 'Cadastro não realizado',
							detail: 'Falha ao cadastrar usuário!',
							life: 5000,
						},
					]);
				});
		}
	};

	const formik = useFormik<ModelOfFormUser>({
		initialValues: {
			CPF: '',
			LOGIN: '',
			NIVEL: 0,
			SENHA: '',
			ORGAO: '',
			ORGAOUNIDADE: '',
			CARGO: '',
		},
		onSubmit: async (values) => saveUser(values),
		validationSchema,
	});

	const searchPersonCpf = async (cpf: string) => {
		setLoadingPersonCpf(true);

		api.post('people/get-person', { CPF: cpf })
			.then((response) => {
				if (!!response.data[0]) {
					setFoundPersonCpf(true);
					setPersonCpf(response.data);
					setLoadingPersonCpf(false);
				}

				if (!response.data.length) {
					setFoundPersonCpf(false);
					setLoadingPersonCpf(false);
					toastUserCpf.current.show({
						severity: 'error',
						summary: 'Cadastro indisponível - CPF não encontrado',
						detail: 'Primeiro cadastre a pessoa em Motorista ou Pessoal!',
						sticky: true,
						closable: false,
					});
				}
			})
			.catch((err) => {
				console.log(err.status);

				setFoundPersonCpf(false);
				setLoadingPersonCpf(false);
			});
	};

	return {
		getUserFormController: {
			formik,
			userResponse,
			toast,
			toastUserCpf,
			loading,
			loadingPersonCpf,
			foundPersonCpf,
			PersonCpf,
		},
		handleUserFormController: {
			searchPersonCpf,
		},
	};
};
